// extracted by mini-css-extract-plugin
export default {"centered":"hMOTa","unsubscribe-width":"_35_gT","unsubscribeWidth":"_35_gT"};